<template>
  <div>
    <b-modal id="bv-modal-delete-site" hide-footer>
      <template #modal-title>Delete site</template>

     <div class="text-center"><b>{{site.name}}</b></div>

        <div class="pb-3 text-center">How many legs does a cow have?</div>

      <div class="row">
        <div class="col">
            <input type="text" placeholder="Answer here" class="form-control2" v-model="content" @paste.prevent>
        </div>
      </div>

      <div class="row pt-3 pb-2">
        <div class="col">
            <button type="button" class="btn btn-danger col" @click="hideModalDeleteSite()">Cancel</button>
        </div>
        <div class="col">
            <button v-if="updating" type="button" class="btn btn-danger col">
            <i class="fas fa-spinner fa-sm fa-spin mr-2 move-up"></i></button>
            <button v-else type="button" class="btn btn-danger col" @click="saveEmail">Delete site</button>
        </div>
      </div>

    </b-modal>
  </div>
</template> 

<script>
import { EventBus } from '../bus';

export default {
props: ['site','page'],
  data() {
    return {
      updating: false,
      content: null,
    };
  },

  methods: {

    hideModalDeleteSite() {
      this.$bvModal.hide('bv-modal-delete-site');
    },

    clearContent() {
      this.content = null;
    },

    saveEmail() {

              if (this.content == null || this.content == '') {this.sweetfire('Please answer the question')}
              else if (!/^four$/i.test(this.content) && this.content != '4') {this.sweetfire('Wrong answer')}

            else {

              this.updating = true;

              axios.post('/websites/delete', {
                id: this.site.id})
                .then((response) => {
                    EventBus.$emit('site-deleted');
                    this.hideModalDeleteSite();
                    if (this.page == 'view') {
                      window.location.href = '/websites';
                    }
                }).catch((error) => {
                  
                    this.sweetfire(error.response.data.message);

                  }).finally(() => {

                  this.updating = false;

                });

          }

      },
            
  },
};
</script>